import { WHITE, GREY_LIGHT, GREY_LIGHT_HIGHLIGHT, BLACK, TURQOISE } from 'constants/colours';
import { SITE_WIDTH } from 'constants/spacing';

export const ICON_SIZE = 25;

export default {
  container: {
    backgroundColor: GREY_LIGHT,
    borderBottomStyle: 'solid',
    borderBottomWidth: 1,
    borderBottomColor: GREY_LIGHT_HIGHLIGHT,
  },

  hoverFix: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
  },

  wrapper: {
    maxWidth: SITE_WIDTH,
    margin: '0 auto',
    display: 'flex',
    alignItems: 'center',
    padding: 10,
    flexDirection: 'column',
  },

  navItems: {
    display: 'flex',
    width: '100%',
  },

  navContent: {
    display: 'flex',
    flex: 1,
    alignItems: 'center',
    position: 'relative',
  },

  logo: {
    width: 350,
    marginBottom: 20,
  },

  iconLinks: {
    flex: 1,
    display: 'flex',
    flexDirection: 'row',
    listStyle: 'none',
    margin: `0 0 0 ${ICON_SIZE}px`,
    padding: 0,
    justifyContent: 'center',
  },

  links: {
    listStyle: 'none',
    margin: 0,
    padding: 0,
    position: 'absolute',
    left: 0,
    right: 0,
    backgroundColor: WHITE,
    borderColor: GREY_LIGHT_HIGHLIGHT,
    borderTopStyle: 'solid',
    borderBottomStyle: 'solid',
    borderWidth: 2,
    zIndex: 2,
  },

  iconLink: {
    width: ICON_SIZE,
    height: ICON_SIZE,
    margin: '0 20px',
  },

  menuButton: {
    width: ICON_SIZE,
    height: ICON_SIZE,
    appearance: 'none',
    background: 'none',
    border: 0,
    padding: 0,
    margin: 0,
    cursor: 'pointer',
    position: 'relative',
    ':focus': {
      outline: 'none',
    },
  },

  buttonColour: BLACK,
  buttonColourHover: TURQOISE,

  hidden: {
    opacity: 0,
  },
};



// WEBPACK FOOTER //
// ./src/components/SiteNav/SiteNav.style.js